import { IApiExpenseItemFilter, IApiExpenseItem, IApiExpenseItemConnection } from './../../../modules/graphql/types/types';
import { ApiConnection } from 'src/app/shared/decorators/@ApiConnection.decorator';
import { DataSource } from "@angular/cdk/collections";
import { ExpenseItemService } from "./expense-item.service";
import { NefcoPagedDataSource } from '../../../helpers/nefco-data-source.class';

export class ExpenseItemDataSource extends NefcoPagedDataSource<IApiExpenseItem, ExpenseItemService, IApiExpenseItemConnection> implements DataSource<IApiExpenseItem> {
  @ApiConnection()
  public load(filters: IApiExpenseItemFilter[] = []): Promise<IApiExpenseItemConnection> {
    return this.service.get(filters, this.listPage).toPromise();
  }
}